import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ContactType} from 'src/app/models';

@Injectable({
    providedIn: 'root'
})
export class ContactTypeService {
    url = '/api/v1/admin/contact-types';

    constructor(public http: HttpClient) {
    }

    addContactType(contactType: any): any {
        return this.http.post<ContactType>(this.url, contactType);
    }

    updateContactType(id: number, contactType: ContactType): any {
        return this.http.put(`${this.url}/${id}`, contactType);
    }

    getContactTypes(): any {
        return this.http.get(this.url);
    }

    removeContactType(id: number): any {
        return this.http.delete(`${this.url}/${id}`);
    }
}
